import React, {
  useState,
  useEffect,
  useRef,
  useMemo,
  useCallback,
} from 'react';
import { createPortal } from 'react-dom';
import Draggable from 'react-draggable';
import {
  MessageList,
  Input,
  ChatList,
  Button,
} from 'react-chat-elements';
import 'react-chat-elements/dist/main.css'; 
import { useNavigate, useLocation } from 'react-router-dom';
import { TextField, IconButton, InputAdornment, Dialog, DialogTitle, DialogContent, List, ListItem, ListItemButton, ListItemAvatar, ListItemText as MuiListItemText, Avatar, CircularProgress, Typography } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SendIcon from '@mui/icons-material/Send';
import PuffLoader from "react-spinners/PuffLoader";
import Lottie from 'lottie-react';
import TypingAnimation from '../../assests/images/Animations/typing.json';
import RecordingAnimation from '../../assests/images/Animations/recording.json';

import { FiSend, FiX } from 'react-icons/fi';
import { FaUserFriends, FaUsers } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
// Services (replace with your actual imports)
import AuthService from '../../Services/auth.service';
import ChatService from '../../Services/chat.conf.service';
import ChatApiService from '../../Services/chat.service';
import ClarificationDocumentService from '../../Services/clarificationDocuments.service';
import TransactionSearchResultModal from '../Widgets/TransactionSearchResultModal/TransactionSearchResultModal';
import { useHamburgerMenu } from '../../Contexts/HamburgerMenuContext';
import LabelService from '../../Services/labels.service';
import moment from 'moment-timezone';
// Example helper or avatar
import UserAvatar from '../Widgets/UserAvatar/UserAvatar';
import './Chat.css';
import ContactsList from './SubComponents/ContactsList';
import ChatHeader from './ChatHeader/ChatHeader';
import ChatInputBar from './SubComponents/ChatInputBar';
import ChatMessagesList from './SubComponents/ChatMessagesList/ChatMessagesList';
import { v4 as uuid } from 'uuid';
import Constants from '../../assests/Constants/constants';
import FilterOptionMenu from '../Widgets/FilterOptionMenu/FilterOptionMenu';
import LabelsList from './SubComponents/LabelsList';
import CustomDeleteConfirmationModal from '../CustomDeleteConfirmationModal/CustomDeleteConfirmationModal';
import CreateLabelModal from './SubComponents/CreateLabelModal';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { toast } from 'react-toastify';
import ManageLabelUsersModal from './ManageLabelUsersModal/ManageLabelUsersModal';
import SearchItem from './SubComponents/SearchItem';
const options = [
  { label: 'Users', value: 'users' },
  { label: 'Groups', value: 'labels' },
];

// Example usage with new options


export default function Chat({ isOpen, onClose, setOpenChat, onOpenManageLabelModal, targetUserId: propTargetUserId, targetUserType: propTargetUserType, targetUserName: propTargetUserName, clarificationAttachContext = null }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [container] = useState(() => document.createElement('div'));
  //--- State
  const {
    targetUserId: paramTargetUserId,
    targetUserType: paramTargetUserType,
    targetUserName: paramTargetUserName,
  } = location.state || {};

  // Use props if provided, otherwise use location state
  const initialTargetUserId = propTargetUserId || paramTargetUserId;
  const initialTargetUserType = propTargetUserType || paramTargetUserType;
  const initialTargetUserName = propTargetUserName || paramTargetUserName;

  // Basic chat states
  const [userId, setUserId] = useState('');
  const [userType, setUserType] = useState('');
  const [messages, setMessages] = useState([]);
  const messagesRef = useRef([]);
  const scrollingToReplyRef = useRef(false);
  const scrollContainerRef = useRef(null);
  const [allowedUsers, setAllowedUsers] = useState([]);
  const [targetUserId, setTargetUserId] = useState('');
  const [targetUserType, setTargetUserType] = useState('');
  const [targetUserName, setTargetUserName] = useState('');
  const [selectedUser, setSelectedUser] = useState(null);
  const { i18n, t } = useTranslation();
  const [showManageLabelModal, setShowManageLabelModal] = useState(false);

  // Pagination states
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize] = useState(20);
  const [hasMore, setHasMore] = useState(true);
  const [fetchedPages, setFetchedPages] = useState(new Set());
  const [lowestPageLoaded, setLowestPageLoaded] = useState(1);
  const [highestPageLoaded, setHighestPageLoaded] = useState(1);
  const [isInitComplete, setIsInitComplete] = useState(false);
  const [loading, setLoading] = useState(false);
  const direction = i18n.dir();
  // Refs to keep track of user info across re-renders
  const targetUserIdRef = useRef(targetUserId);
  const targetUserTypeRef = useRef(targetUserType);
  const targetUserNameRef = useRef(targetUserName);
  const currentUserIdRef = useRef(userId);
  const currentUserTypeRef = useRef(userType);

  // Typing / Online states
  const [isTyping, setIsTyping] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [recorder, setRecorder] = useState(null);
  const [isTargetRecording, setIsTargetRecording] = useState(false);
  const meteringLevelRef = useRef(-160);
  const analyserRef = useRef(null);
  const audioContextRef = useRef(null);
  const meteringIntervalRef = useRef(null);
  const pcmChunksRef = useRef([]);
  const micStreamRef = useRef(null);
  const [isOnline, setIsOnline] = useState(false);
  const typingTimeout = useRef(null);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);

  // Search & filter states
  const [viewMode, setViewMode] = useState('users');
  const [labels, setLabels] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [listSearchedText, setListSearchedText] = useState('');
  const [getAllForReceiver, setGetAllForReceiver] = useState(false);
  const audioChunksRef = useRef([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  // Text input
  const [inputValue, setInputValue] = useState('');
  const [showCreateLabelModal, setShowCreateLabelModal] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState(null);
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [replyingMessage, setReplyingMessage] = useState(null);
  const replyingMessageRef = useRef(null);
  const [searchChatQuery, setSearchChatQuery] = useState('');
  const [listChatSearchedText, setListChatSearchedText] = useState('');
  const scrollToIndexRef = useRef(null);

  // Forward to chat state
  const [showForwardPicker, setShowForwardPicker] = useState(false);
  const [forwardChatUsers, setForwardChatUsers] = useState([]);
  const [forwardUserSearch, setForwardUserSearch] = useState('');
  const [loadingForwardUsers, setLoadingForwardUsers] = useState(false);
  const [messagesToForward, setMessagesToForward] = useState([]);

  const [docPickerOpen, setDocPickerOpen] = useState(false);
  const [pendingAttachMessages, setPendingAttachMessages] = useState([]);
  const [searchToken, setSearchToken] = useState('');
  const [searchAccountantId, setSearchAccountantId] = useState('');
  const hamburgerMenu = useHamburgerMenu();
  const hamburgerClient = hamburgerMenu?.client || hamburgerMenu?.menuProps?.client;
  const hamburgerUser = hamburgerMenu?.user;
  const accountCardOptions = hamburgerMenu?.accountCardOptions || [];
  const sortCodeIdOptions = hamburgerMenu?.sortCodeIdOptions || [];
  useEffect(() => {
    const delaySearch = setTimeout(() => {
      setListChatSearchedText(searchChatQuery.trim());
    }, 300);

    return () => clearTimeout(delaySearch);
  }, [searchChatQuery]);

  useEffect(() => {
    if (isSearchMode) {
      handleSearchSubmit()
    }
  }, [listChatSearchedText]);


  function updateMessages(updater) {
    if (typeof updater === 'function') {
      setMessages(prev => {
        const next = updater(prev);
        messagesRef.current = next;
        return next;
      });
    } else {
      messagesRef.current = updater;
      setMessages(updater);
    }
  }
  const changeForReceiver = (checked) => {
    setFetchedPages(new Set());
    setMessages([]);
    setGetAllForReceiver(checked);
    fetchMessages(1, false, checked);

  }
  const handleSearchSubmit = async () => {
    try {

      // Example: call an endpoint that returns a list of messages matching searchQuery
      const results = await ChatApiService.searchMessages(
        userId,
        userType,
        targetUserId,
        targetUserType,
        listChatSearchedText
      );
      // Suppose results come back as an array of objects:
      // { messageId, excerpt, pageNumber, senderId, messageDate, ... }

      setSearchResults(results);
    } catch (error) {
      console.error(error);
    }
  };

  const handleSelectSearchResult = async (item) => {
    // 1) Clear current messages
    setFetchedPages(new Set());
    setMessages([]);

    // 2) Move pagination to the page where the match was found
    setLowestPageLoaded(item.pageNumber);
    setHighestPageLoaded(item.pageNumber);

    // 3) Fetch that page’s messages
    await fetchMessages(item.pageNumber);

    // 4) Close search mode
    onCancelSearch();
  };

  const handleSelectSearchResult2 = async (item) => {
    setFetchedPages(new Set());
    setMessages([]);
    setLowestPageLoaded(item.pageNumber);
    setHighestPageLoaded(item.pageNumber);
    await fetchMessages(item.pageNumber);

    // Exit search mode
    onCancelSearch();
  };

  const handleSearchPress = () => {
    setIsSearchMode(true);
    setSearchQuery('');
    setSearchResults([]);
  };

  const onCancelSearch = () => {
    setIsSearchMode(false);
    setSearchQuery('');
    setSearchResults([]);
  };

  const handleOpenModal = () => {
    setShowCreateLabelModal(true);
  };

  const handleCloseModal = () => {
    setShowCreateLabelModal(false);
  };

  const onLabelCreated = async (labelId, labelName) => {

    await refreshAllowedUsers(currentUserIdRef.current, currentUserTypeRef.current);
  };

  // For Draggable modal
  const draggableNodeRef = useRef(null);

  // ChatService ref
  const chatService = useRef(null);

  // File input ref (hidden input for attachments)
  const fileInputRef = useRef(null);

  const optionGroups = [
    {
      title: t('Status'),
      selectionType: 'single',
      options: [
        { id: 'read', label: t('Read') },
        { id: 'unread', label: t('Unread') },
        { id: 'all', label: t('All') },
      ],
    },
    {
      title: t('UserType'),
      selectionType: 'multi',
      options: [
        { id: 'business', label: t('Business') },
        { id: 'office', label: t('Office') },
      ],
    },
    {
      title: t('CaseType'),
      selectionType: 'multi',
      options: Constants.CaseTypeOptions.map((option) => ({
        id: option.value,
        label: option.name,
      })),
    },
    {
      title: t('AccountManagement'),
      selectionType: 'multi',
      options: Constants.AccountManagementOptions.map((option) => ({
        id: option.value,
        label: option.name,
      })),
    },
    {
      title: t('ReportingType'),
      selectionType: 'multi',
      options: Constants.ReportingTypeOptions.map((option) => ({
        id: option.value,
        label: option.name,
      })),
    },
  ];

  /**
   * ------------------------------
   *         Effect Hooks
   * ------------------------------
   */

  useEffect(() => {
    document.body.appendChild(container);
    return () => {
      try {
        document.body.removeChild(container);
      } catch (e) {
        // Ignore
      }
    };
  }, [container]);

  // Debounce the user list search
  useEffect(() => {
    const delaySearch = setTimeout(() => {
      setListSearchedText(searchQuery.trim());
    }, 300);
    return () => clearTimeout(delaySearch);
  }, [searchQuery]);

  // Initialize chat and connect to your chat service
  useEffect(() => {
    const init = async () => {
      setLoading(true);
      try {
        const currentUserTypeVal = await AuthService.getCurrentUserType();
        const currentUserIdVal = await AuthService.getCurrentUserTypeId();
        setUserId(currentUserIdVal);
        setUserType(currentUserTypeVal);
        chatService.current = new ChatService();
        await chatService.current.startConnection();

        // Subscribe to chat events
        chatService.current.subscribe('UserSend', handleUserSend);
        chatService.current.subscribe('MessageRead', handleMessageRead);
        chatService.current.subscribe('Typing', handleTypingEvent);
        chatService.current.subscribe('UserActive', handleUserActive);
        chatService.current.subscribe('IsRecording', handleIsRecordingEvent);

        // Fetch initial list of allowed users
        await refreshAllowedUsers(currentUserIdVal, currentUserTypeVal);
      } catch (err) {
        console.error('Error initializing chat:', err);
      }
      setLoading(false);
      setIsInitComplete(true);
    };

    init();

    // Cleanup
    return () => {
      if (chatService.current && chatService.current.isConnected) {
        chatService.current.unsubscribe('UserSend', handleUserSend);
        chatService.current.unsubscribe('MessageRead', handleMessageRead);
        chatService.current.unsubscribe('Typing', handleTypingEvent);
        chatService.current.unsubscribe('UserActive', handleUserActive);
        chatService.current.unsubscribe('IsRecording', handleIsRecordingEvent);
      }
    };
  }, []);

  // If the component is initialized and there's a target user passed from location
  useEffect(() => {
    if (isInitComplete && initialTargetUserId && initialTargetUserType && initialTargetUserName) {
      // Set the selectedUser immediately when props are provided
      setSelectedUser({
        userId: initialTargetUserId,
        userType: parseInt(initialTargetUserType, 10),
        name: initialTargetUserName,
      });
      
      // Also call onUserSelect to handle the full selection logic
      onUserSelect({
        userId: initialTargetUserId,
        userType: parseInt(initialTargetUserType, 10),
        userName: initialTargetUserName,
      });
    }
  }, [isInitComplete, initialTargetUserId, initialTargetUserType, initialTargetUserName]);

  // Whenever target user changes, reload messages
  useEffect(() => {

    if (targetUserId && targetUserType) {
      targetUserIdRef.current = targetUserId;
      targetUserTypeRef.current = targetUserType;
      targetUserNameRef.current = targetUserName;
      // Check if user is online (replace this with an actual call if needed)
      checkUserOnline(targetUserId);
      reloadMessages(false);
    }
  }, [targetUserId, targetUserType]);

  // Keep current user info in sync with refs
  useEffect(() => {
    currentUserIdRef.current = userId;
    currentUserTypeRef.current = userType;
  }, [userId, userType]);

  // Handle when target user props change (for when chat is opened from EditModal)
  useEffect(() => {
    if (isInitComplete && propTargetUserId && propTargetUserType && propTargetUserName) {
      console.log('Chat: Setting selectedUser from props:', {
        userId: propTargetUserId,
        userType: propTargetUserType,
        name: propTargetUserName
      });
      
      // Update selectedUser when props change
      setSelectedUser({
        userId: propTargetUserId,
        userType: parseInt(propTargetUserType, 10),
        name: propTargetUserName,
      });
      
      // Update target user state
      setTargetUserId(propTargetUserId);
      setTargetUserType(propTargetUserType);
      setTargetUserName(propTargetUserName);
    }
  }, [isInitComplete, propTargetUserId, propTargetUserType, propTargetUserName]);

  /**
   * ------------------------------
   *        Event Handlers
   * ------------------------------
   */
  const handleUserSend = async (senderId, senderType) => {
    const currentTargetUserId = targetUserIdRef.current;
    const currentTargetUserType = targetUserTypeRef.current;
    const currentSenderUserId = currentUserIdRef.current;
    const currentSenderUserType = currentUserTypeRef.current;


    // If message is from the currently selected user
    if (senderId === currentTargetUserId && senderType === currentTargetUserType) {
      await ChatApiService.readMessage(currentSenderUserId, currentSenderUserType, currentTargetUserId, currentTargetUserType, true);
      await reloadMessagesFor(currentSenderUserId, currentSenderUserType, currentTargetUserId, currentTargetUserType);

    } else {
      await refreshAllowedUsers(currentSenderUserId, currentSenderUserType);
    }
  };




  const handleMessageRead = (readerId, readerType, readTimestamp) => {
    const currentTargetUserId = targetUserIdRef.current;
    const currentTargetUserType = targetUserTypeRef.current;


    if (readerId === currentTargetUserId && readerType === currentTargetUserType) {
      const readTime = parseIsraelDate(readTimestamp);

      setMessages((prevMessages) => {
        // Find the last message that matches the criteria
        const lastMessageIndex = prevMessages
          .slice()
          .reverse()
          .findIndex(
            (msg) =>
              msg.position === 'right' &&
              new Date(msg.date) <= readTime
          );

        // If no valid message is found, return previous messages unchanged
        if (lastMessageIndex === -1) return prevMessages;

        // Get the index of the last message in the original order
        const targetIndex = prevMessages.length - 1 - lastMessageIndex;

        return prevMessages.map((msg, index) => {
          if (index === targetIndex) {
            return {
              ...msg,
              receiverReadAt: readTime, // Add ReceiverReadAt to the last read message
            };
          }

          // Clear any previous `receiverReadAt` if a new one is being set
          return {
            ...msg,
            receiverReadAt: null,
          };
        });
      });
    }
  };


  const handleTypingEvent = (senderId, senderType) => {
    const currentTargetUserId = targetUserIdRef.current;
    const currentTargetUserType = targetUserTypeRef.current;
    if (senderId === currentTargetUserId && senderType === currentTargetUserType) {
      setIsTyping(true);
      if (typingTimeout.current) clearTimeout(typingTimeout.current);
      typingTimeout.current = setTimeout(() => setIsTyping(false), 3000);
    }
  };

  const handleIsRecordingEvent = (senderId, senderType, isRecording) => {
    const currentTargetUserId = targetUserIdRef.current;
    const currentTargetUserType = targetUserTypeRef.current;

    if (senderId === currentTargetUserId && senderType === currentTargetUserType) {
      setIsTargetRecording(isRecording);
    }
  };
  const deselectUser = () => {
    setMessages([]);
    setSelectedUser(null);
    setTargetUserId(null);
    setTargetUserType(null);
    setTargetUserName(null);
    setFetchedPages(new Set());
  };
  const handleUserActive = (userId, active) => {
    const currentTargetUserId = targetUserIdRef.current;
    if (userId === currentTargetUserId) {
      setIsOnline(active);
    }
  };

  const onUserSelect = async (item) => {

    // If the selected user is the same, trigger deselect and reselect
    if (item.userId === targetUserId && item.userType === targetUserType) {
      deselectUser();
      setTimeout(() => {
        selectUser(item);
      }, 0); // Short delay to allow deselection to take effect
    } else {
      selectUser(item);
    }
  };

  const onLabelSelect = (label) => {
    onOpenManageLabelModal(label, allowedUsers);
  };


  const onLabelDelete = async () => {
    try {
      if (itemToDelete) {
        await LabelService.deleteLabel(itemToDelete.labelId);
        const updatedLabels = labels.filter((l) => l.labelId !== itemToDelete.labelId); // Assuming you have a labels state
        setLabels(updatedLabels);
      }
    } catch (error) {
      console.error('Error deleting label:', error);
    } finally {
      setIsModalVisible(false);
      setItemToDelete(null);
    }
  };


  // Separate the user selection logic into its own function
  const selectUser = async (item) => {
    setTargetUserName(item.userName);
    setTargetUserId(item.userId);
    setTargetUserType(item.userType);
    setGetAllForReceiver(false)
    // Mark as selected user
    setSelectedUser({
      userId: item.userId,
      userType: item.userType,
      name: item.userName,
    });
    const isSelectedUserOnline = await ChatApiService.checkUserOnlineStatus(item.userId);
    setIsOnline(isSelectedUserOnline);
    // Read any unread messages
    await ChatApiService.readMessage(userId, userType, item.userId, item.userType);
    await refreshAllowedUsers(userId, userType);
  };

  /**
   * ------------------------------
   *          CRUD & APIS
   * ------------------------------
   */

  // Refresh the list of allowed users (or labels)
  const refreshAllowedUsers = async (uId, uType) => {
    if (!uId || !uType) return;
    try {

      if (uType.toString() !== '1') {

        // fetch labels
        const labelList = await LabelService.listLabels();
        setLabels(labelList);
      }

      // fetch allowed users
      const data = await ChatApiService.getAllowedUsers(uId, uType);
      data.sort((a, b) => b.unreadMessagesCount - a.unreadMessagesCount);
      setAllowedUsers(data);
    } catch (err) {
      console.error('Error fetching allowed users:', err);
    }
  };

  // Check if user is online (dummy - adapt to your actual logic)
  const checkUserOnline = async (uId) => {
    const isOnlineStatus = await ChatApiService.checkUserOnlineStatus(uId);
    setIsOnline(isOnlineStatus);
  };

  /**
   * ------------------------------
   *      Messages & Pagination
   * ------------------------------
   */

  const handleReplyToMessage = (msg) => {
    setReplyingMessage(msg);
    replyingMessageRef.current = msg; // store in ref as well
  };

  async function scrollToRepliedMessageWithPage(repliedMessageId, startPage = 1, attempt = 0) {
    const maxAttempts = 5;

    if (attempt === 0) {
      scrollingToReplyRef.current = true;
    }

    if (attempt >= maxAttempts) {
      console.warn(`Reached ${maxAttempts} attempts, still can't find message ${repliedMessageId}.`);
      scrollingToReplyRef.current = false;
      return;
    }

    const current = messagesRef.current;
    const index = current.findIndex(m => m.id === repliedMessageId);

    if (index === -1) {
      const nextPage = startPage + attempt;
      await fetchMessages(nextPage, true, getAllForReceiver);
      await new Promise(resolve => requestAnimationFrame(() => setTimeout(resolve, 200)));
      return scrollToRepliedMessageWithPage(repliedMessageId, startPage, attempt + 1);
    }

    await new Promise(resolve => setTimeout(resolve, 100));

    if (scrollToIndexRef.current) {
      scrollToIndexRef.current(index);
    }

    // Stop preventing scroll triggers after some delay
    setTimeout(() => {
      scrollingToReplyRef.current = false;
    }, 500);
  }


  function handleRepliedMessageClick(repliedMessageId) {
    scrollToRepliedMessageWithPage(repliedMessageId, highestPageLoaded + 1);
  }

  const reloadMessages = async (checkPage = true) => {
    setFetchedPages(new Set());
    setPageNumber(1);
    setHasMore(true);
    setLowestPageLoaded(1);
    setHighestPageLoaded(1);
    await refreshAllowedUsers(currentUserIdRef.current, currentUserTypeRef.current);
    await fetchMessages(1, checkPage);
  };

  // If you need a separate function to reload by passing IDs explicitly
  const reloadMessagesFor = async (senderId, senderType, tId, tType) => {
    setPageNumber(1);
    setHasMore(true);
    setFetchedPages(new Set());
    setLowestPageLoaded(1);
    setHighestPageLoaded(1);
    await fetchMessages2(1, senderId, senderType, tId, tType);
  };

  const getSenderTitle = (senderId) => {
    const matchedUser = allowedUsers.find((user) => user.userId === senderId);
    return matchedUser ? matchedUser.userName : 'unknown';
  };

  // Main fetch messages
  // Updated fetchMessages
  const fetchMessages = async (page, checkPage = true, GetAllForReceiver = false) => {


    if (!targetUserId || !targetUserType) return;

    // Check if page already fetched
    if (checkPage && fetchedPages.has(page)) {
      return;
    }
    const senderName = await AuthService.getCurrentUserTypeName();
    try {
      const data = await ChatApiService.fetchMessages(userId, userType, targetUserId, targetUserType, page, pageSize, GetAllForReceiver);

      const fetchedMessages = data.messages.map(msg => {

        const message = {
          id: msg.id,
          position: msg.senderId === userId ? 'right' : 'left',
          type:
            msg.messageType === 1
              ? 'photo'
              : msg.messageType === 3
                ? 'audio'
                : msg.messageType === 2
                  ? 'file'
                  : 'text',
          text: msg.messageType === 0 ? msg.messageContent : '',
          date: parseIsraelDate(msg.messageDate),
          dateString: formatMessageDate(msg.messageDate),
          receiverReadAt: parseIsraelDate(msg.receiverReadAt),
          title: msg.senderId === userId ? senderName : GetAllForReceiver ? getSenderTitle(msg.senderId) : targetUserName,
          senderId: msg.senderId,
          senderName: msg.senderId === userId ? senderName : (GetAllForReceiver ? getSenderTitle(msg.senderId) : targetUserName),
          receiverId: msg.receiverId,
          receiverName: msg.senderId === userId ? targetUserName : senderName,
          messageType: msg.messageType,
          fileUrls: msg.fileUrls || [],
          replyToChatMessageId: msg.replyToMessageId || null,
          replyPreview: msg.replyPreview || null,
          data: {},
          replyTo: msg.replyToMessageId
            ? {
              id: msg.replyToMessageId,
              text: msg.replyPreview || t('MediaMessage'),
            }
            : null,
        };


        // handle files/audios/photos
        // Handle multiple file URLs for photos, audio, and files
        if (msg.messageType === 1 && msg.fileUrls?.length > 0) {
          // For photos
          message.data = { uris: msg.fileUrls }; // Store all image URLs
        } else if (msg.messageType === 3 && msg.fileUrls?.length > 0) {
          // For audio
          message.data = { audioURLs: msg.fileUrls }; // Store all audio URLs
        } else if (msg.messageType === 2 && msg.fileUrls?.length > 0) {
          // For files
          message.data = { fileURLs: msg.fileUrls }; // Store all file URLs
        }

        return message;
      }).reverse();

      if (page < lowestPageLoaded) {
        // setMessages(prev => [...prev, ...fetchedMessages]);
        updateMessages(prev => [...prev, ...fetchedMessages])
        setLowestPageLoaded(page);
      } else if (page > highestPageLoaded) {
        // setMessages(prev => [...fetchedMessages, ...prev]);
        updateMessages(prev => [...fetchedMessages, ...prev])
        setHighestPageLoaded(page);
      } else {
        // setMessages(fetchedMessages);
        updateMessages(fetchedMessages);
        setLowestPageLoaded(page);
        setHighestPageLoaded(page);
      }

      setFetchedPages(prevSet => new Set(prevSet).add(page));

      if (fetchedMessages.length < pageSize) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
    } catch (error) {
      console.error('Error fetching messages:', error);
    }
  };

  const fetchMessages2 = async (page, senderId, senderType, targetId, targetType) => {

    if (!targetId || !targetType) return;

    const senderName = await AuthService.getCurrentUserTypeName();
    try {
      const data = await ChatApiService.fetchMessages(senderId, senderType, targetId, targetType, page, pageSize, getAllForReceiver);

      const fetchedMessages = data.messages.map(msg => {

        const message = {
          id: msg.id,
          position: msg.senderId === currentUserIdRef.current ? 'right' : 'left',
          type:
            msg.messageType === 1
              ? 'photo'
              : msg.messageType === 3
                ? 'audio'
                : msg.messageType === 2
                  ? 'file'
                  : 'text',
          text: msg.messageType === 0 ? msg.messageContent : '',
          date: parseIsraelDate(msg.messageDate),
          dateString: formatMessageDate(msg.messageDate),
          receiverReadAt: parseIsraelDate(msg.receiverReadAt),
          title: msg.senderId === currentUserIdRef.current ? senderName : targetUserName,
          senderId: msg.senderId,
          senderName: msg.senderId === currentUserIdRef.current ? senderName : targetUserName,
          receiverId: msg.receiverId,
          receiverName: msg.senderId === currentUserIdRef.current ? targetUserName : senderName,
          messageType: msg.messageType,
          fileUrls: msg.fileUrls || [],
          replyToChatMessageId: msg.replyToMessageId || null,
          replyPreview: msg.replyPreview || null,
          data: {},
          replyTo: msg.replyToMessageId
            ? {
              id: msg.replyToMessageId,
              text: msg.replyPreview || t('MediaMessage'),
            }
            : null,
        };


        // handle files/audios/photos
        // Handle multiple file URLs for photos, audio, and files
        if (msg.messageType === 1 && msg.fileUrls?.length > 0) {
          // For photos
          message.data = { uris: msg.fileUrls }; // Store all image URLs
        } else if (msg.messageType === 3 && msg.fileUrls?.length > 0) {
          // For audio
          message.data = { audioURLs: msg.fileUrls }; // Store all audio URLs
        } else if (msg.messageType === 2 && msg.fileUrls?.length > 0) {
          // For files
          message.data = { fileURLs: msg.fileUrls }; // Store all file URLs
        }

        return message;
      }).reverse();

      if (page < lowestPageLoaded) {
        // setMessages(prev => [...prev, ...fetchedMessages]);
        updateMessages(prev => [...prev, ...fetchedMessages])
        setLowestPageLoaded(page);
      } else if (page > highestPageLoaded) {
        // setMessages(prev => [...fetchedMessages, ...prev]);
        updateMessages(prev => [...fetchedMessages, ...prev])
        setHighestPageLoaded(page);
      } else {
        // setMessages(fetchedMessages);
        updateMessages(fetchedMessages);
        setLowestPageLoaded(page);
        setHighestPageLoaded(page);
      }

      setFetchedPages(prevSet => new Set(prevSet).add(page));

      if (fetchedMessages.length < pageSize) {
        setHasMore(false);
      } else {
        setHasMore(true);
      }
    } catch (error) {
      console.error('Error fetching messages:', error);
    }
  };

  const handleImageClick = (uri) => {

    window.open(uri, '_blank');
  };

  const handleDelete = (label) => {

    setItemToDelete(label);
    setIsModalVisible(true);
  };
  const handleCloseDelete = () => {
    setItemToDelete(null);
    setIsModalVisible(false);
  };
  // Scroll-to-load logic
  const handleScroll = ({ scrollTop, scrollHeight, clientHeight }) => {
    if (scrollingToReplyRef.current) {
      return;
    }

    if (scrollTop === 0) {
      loadOlderMessages();
    }

    if (scrollTop + clientHeight >= scrollHeight) {
      loadNewerMessages();
    }
  };


  const loadOlderMessages = async () => {
    const nextPage = highestPageLoaded + 1;
  
    if (hasMore && !fetchedPages.has(nextPage)) {
      const container = scrollContainerRef.current;
      if (!container) return;
  
      const prevScrollHeight = container.scrollHeight;
      const prevScrollTop = container.scrollTop;
  
      await fetchMessages(nextPage, true, getAllForReceiver);
      setHighestPageLoaded(nextPage);
  
      // Wait for virtualizer to render
      setTimeout(() => {
        const newScrollHeight = container.scrollHeight;
        const scrollDiff = newScrollHeight - prevScrollHeight;
        container.scrollTop = prevScrollTop + scrollDiff;
      }, 50);
    }
  };
  
  


  const loadNewerMessages = async () => {

    // Only load if `lowestPageLoaded` is greater than 1, 
    // meaning there is a page before the currently lowest loaded page
    if (lowestPageLoaded > 1) {
      const nextPage = lowestPageLoaded - 1;
      // Check if we haven't already fetched this page
      if (!fetchedPages.has(nextPage)) {
        await fetchMessages(nextPage, true, getAllForReceiver);
        setLowestPageLoaded(nextPage);
      }
    }
  };
  /**
   * ------------------------------
   *         Sending Messages
   * ------------------------------
   */


  const formatMessageDate = (date) => {
    // If it’s older than a day, show `DD/MM HH:mm`
    // Otherwise, you might still show the same format or another. 
    // For simplicity, we'll *always* show "DD/MM HH:mm" in Israel time:
    const raw = typeof date === 'string' ? date.replace('Z', '') : date;
    return moment.tz(raw, 'Asia/Jerusalem').format('DD/MM HH:mm');
  };

  const parseIsraelDate = (date) => {
    if (!date) return null;
    const raw = typeof date === 'string' ? date.replace('Z', '') : date;
    return moment.tz(raw, 'Asia/Jerusalem').toDate();
  };

  /**
   * ------------------------------
   *        Searching / Filtering
   * ------------------------------
   */
  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  // Filter the user list
  const filteredAllowedUsers = useMemo(() => {
    let filtered = allowedUsers;

    const trimmedSearchQuery = listSearchedText?.trim()?.toLowerCase();

    if (trimmedSearchQuery) {
      filtered = filtered.filter(user => {
        const nameMatch = user?.userName?.toLowerCase()?.includes(trimmedSearchQuery);
        const idMatch = user?.userId?.toLowerCase()?.includes(trimmedSearchQuery);
        const unreadMatch = user?.unreadMessagesCount?.toString().includes(trimmedSearchQuery);
        return nameMatch || idMatch || unreadMatch;
      });
    }

    if (selectedOptions.includes('read')) {
      filtered = filtered.filter(user => user?.unreadMessagesCount === 0);
    } else if (selectedOptions.includes('unread')) {
      filtered = filtered.filter(user => user?.unreadMessagesCount > 0);
    }

    if (selectedOptions.includes('business')) {
      filtered = filtered.filter(user => user.userType === 1);
    }

    if (selectedOptions.includes('office')) {
      filtered = filtered.filter(user => user.userType !== 1);
    }

    // Filter by multiple selected CaseTypeOptions
    const selectedCaseTypes = selectedOptions.filter(option =>
      Constants.CaseTypeOptions.some(o => o.value === option)
    );
    if (selectedCaseTypes.length > 0) {
      filtered = filtered.filter(user =>
        selectedCaseTypes.includes(user.caseType)
      );
    }

    // Filter by multiple selected AccountManagementOptions
    const selectedAccountManagements = selectedOptions.filter(option =>
      Constants.AccountManagementOptions.some(o => o.value === option)
    );
    if (selectedAccountManagements.length > 0) {
      filtered = filtered.filter(user =>
        selectedAccountManagements.includes(user.accountManagement)
      );
    }

    // Filter by multiple selected ReportingTypeOptions
    const selectedReportingTypes = selectedOptions.filter(option =>
      Constants.ReportingTypeOptions.some(o => o.value === option)
    );
    if (selectedReportingTypes.length > 0) {
      filtered = filtered.filter(user =>
        selectedReportingTypes.includes(user.reportingType)
      );
    }

    return filtered;
  }, [allowedUsers, listSearchedText, selectedOptions]);

  const filteredLabels = useMemo(() => {
    let filtered = labels;

    // Apply search query filter
    const trimmedSearchQuery = listSearchedText?.trim()?.toLowerCase();
    if (trimmedSearchQuery) {
      filtered = filtered.filter(label => {
        const nameMatch = label?.labelName?.toLowerCase()?.includes(trimmedSearchQuery);
        const userMatch = label?.users?.some(user =>
          user?.userName?.toLowerCase()?.includes(trimmedSearchQuery)
        );
        return nameMatch || userMatch;
      });
    }

    return filtered;
  }, [labels, listSearchedText]);

  function updateMessageWithServerResponse(prevMessages, newMessageId, response, repliedMessage) {
    return prevMessages.map((msg) => {
      if (msg.id !== newMessageId) return msg;

      // Try to find reply target message text
      let replyTo = null;

      if (response.repliedMessageId) {
        // First, try from the repliedMessage ref
        if (repliedMessage && repliedMessage.id?.toString() === response.repliedMessageId?.toString()) {

          replyTo = {
            id: repliedMessage.id,
            text: repliedMessage.text || 'MediaMessage',
          };
        } else {
          // Otherwise search in prevMessages
          const found = prevMessages.find(m => m.id === response.repliedMessageId);
          if (found) {
            replyTo = {
              id: found.id,
              text: found.text || 'MediaMessage',
            };
          }
        }
      }

      return {
        ...msg,
        id: response.id,
        sending: false,
        date: parseIsraelDate(response.messageDate),
        dateString: formatMessageDate(response.messageDate),
        replyTo,
      };
    });
  }



  const handleSendMessage = async (message) => {
    const senderName = await AuthService.getCurrentUserTypeName();
    const newMessage = {
      id: uuid(), // Temporary unique ID for the UI
      position: "right", // Since the sender is always the current user
      type: message.type || "text",
      text: message.text || "",
      date: moment().tz("Asia/Jerusalem").toDate(),
      dateString: formatMessageDate(moment().tz("Asia/Jerusalem").toDate()),
      title: senderName,
      senderId: userId,
      senderName,
      receiverId: targetUserId,
      receiverName: targetUserName,
      messageType: message.type === "text" ? 0 : message.type === "photo" ? 1 : message.type === "audio" ? 3 : 2,
      fileUrls: [],
      data: {},
      sending: true, // Mark as sending
    };

    if (message.type === "photo") {
      newMessage.data = { uris: message.files?.map((file) => URL.createObjectURL(file)) || [] };
      newMessage.fileUrls = newMessage.data.uris;
    } else if (message.type === "audio") {
      newMessage.data = { audioURLs: message.files?.map((file) => URL.createObjectURL(file)) || [] };
      newMessage.fileUrls = newMessage.data.audioURLs;
    } else if (message.type === "file") {

      newMessage.data = { fileURLs: message.files?.map((file) => `${URL.createObjectURL(file)}|${file.name}`) || [] };
      newMessage.fileUrls = newMessage.data.fileURLs;

    }

    // Add the message to the UI with a `sending` status
    setMessages((prevMessages) => [...prevMessages, newMessage]);

    // Create FormData for the API
    const formData = new FormData();
    formData.append("SenderId", userId);
    formData.append("SenderName", senderName);
    formData.append("SenderType", userType);
    formData.append("ReceiverId", targetUserId);
    formData.append("ReceiverType", targetUserType);
    formData.append("MessageType", message.type === "text" ? "0" : message.type === "photo" ? "1" : message.type === "audio" ? "3" : "2");
    formData.append("MessageContent", message.text || "");

    if (message.files) {
      message.files.forEach((file) => {
        formData.append("Files", file, file.name);
      });
    }


    if (replyingMessageRef.current) {
      formData.append('ReplyToMessageId', replyingMessageRef.current.id);
    }

    try {
      const response = await ChatApiService.sendMessage(formData);

      // Update the message in the UI to reflect success
      // setMessages((prevMessages) =>
      //   prevMessages.map((msg) =>
      //     msg.id === newMessage.id
      //       ? { ...msg, id: response.id, sending: false, date: new Date(response.messageDate), dateString: formatMessageDate(response.messageDate) }
      //       : msg
      //   )
      // );

      setMessages((prev) => updateMessageWithServerResponse(prev, newMessage.id, response?.data, replyingMessageRef.current));

    } catch (error) {
      console.error("Error sending message:", error);

      // Mark the message as failed
      setMessages((prevMessages) =>
        prevMessages.map((msg) =>
          msg.id === newMessage.id ? { ...msg, sending: "failed" } : msg
        )
      );
    }
    setReplyingMessage(null);
    replyingMessageRef.current = null;
  };


  const handleAttachFiles = (files) => {
    const formattedFiles = Array.from(files).map((file) => ({
      id: uuid(),
      file,
      name: file.name,
    }));

    // Send files as a message
    handleSendMessage({
      type: "file",
      files: formattedFiles.map((file) => file.file),
    });
  };


  const retrySendMessage = (failedMessage) => {
    handleSendMessage({
      text: failedMessage.text,
      type: failedMessage.type,
      files: failedMessage.data?.uris || failedMessage.data?.audioURLs || failedMessage.data?.fileURLs,
    });
  };

  const handleForwardMessages = async (selectedMsgs) => {
    setMessagesToForward(selectedMsgs);
    setShowForwardPicker(true);
    setLoadingForwardUsers(true);
    try {
      const uId = currentUserIdRef.current;
      const uType = currentUserTypeRef.current;
      if (uId && uType) {
        const users = await ChatApiService.getAllowedUsers(uId, uType);
        setForwardChatUsers(users || []);
      }
    } catch (error) {
      console.error('Error fetching chat users for forward:', error);
      toast.error(t('ForwardError'));
    } finally {
      setLoadingForwardUsers(false);
    }
  };

  const handleForwardToUser = async (forwardTarget) => {
    setShowForwardPicker(false);
    setForwardUserSearch('');

    try {
      const senderName = await AuthService.getCurrentUserTypeName();

      for (const msg of messagesToForward) {
        const formData = new FormData();
        formData.append('SenderId', currentUserIdRef.current);
        formData.append('SenderName', senderName);
        formData.append('SenderType', currentUserTypeRef.current);
        formData.append('ReceiverId', forwardTarget.userId);
        formData.append('ReceiverType', forwardTarget.userType?.toString());
        formData.append('ReplyToMessageId', '');

        const hasImages = msg.type === 'photo' && msg.data?.uris?.length > 0;
        const hasAudio = msg.type === 'audio' && msg.data?.audioURLs?.length > 0;
        const hasFiles = msg.type === 'file' && msg.data?.fileURLs?.length > 0;

        if (hasImages) {
          formData.append('MessageType', '1');
          formData.append('MessageContent', '');
          for (const imgUrl of msg.data.uris) {
            const response = await fetch(imgUrl);
            const blob = await response.blob();
            formData.append('Files', blob, `forwarded_image_${Date.now()}.jpg`);
          }
        } else if (hasAudio) {
          formData.append('MessageType', '3');
          formData.append('MessageContent', '');
          for (const audioUrl of msg.data.audioURLs) {
            const response = await fetch(audioUrl);
            const blob = await response.blob();
            formData.append('Files', blob, `forwarded_audio_${Date.now()}.mp4`);
          }
        } else if (hasFiles) {
          formData.append('MessageType', '2');
          formData.append('MessageContent', '');
          for (const fileEntry of msg.data.fileURLs) {
            const [fileUrl, fileName] = fileEntry.includes('|') ? fileEntry.split('|') : [fileEntry, `forwarded_file_${Date.now()}`];
            const response = await fetch(fileUrl);
            const blob = await response.blob();
            formData.append('Files', blob, fileName);
          }
        } else {
          formData.append('MessageType', '0');
          formData.append('MessageContent', msg.text || '');
        }

        await ChatApiService.sendMessage(formData);
      }

      if (chatService.current && chatService.current.isConnected) {
        await chatService.current.notifyUserSend(forwardTarget.userId, forwardTarget.userType);
      }

      toast.success(t('ForwardSuccess'));
    } catch (error) {
      console.error('Error forwarding messages:', error);
      toast.error(t('ForwardError'));
    } finally {
      setMessagesToForward([]);
    }
  };

  const openDocPicker = async (selectedMsgs) => {
    const token = await AuthService.getCurrentToken();
    const accountantId = await AuthService.getCurrentUserTypeAccountantId();
    if (!token || !accountantId || !targetUserIdRef.current) {
      toast.error(t('AttachClarificationMessagesFailed') || 'Failed to attach messages');
      return;
    }
    setPendingAttachMessages(selectedMsgs);
    setSearchToken(token);
    setSearchAccountantId(accountantId);
    setDocPickerOpen(true);
  };

  // Attach messages to a specific document
  const attachMessagesToDocument = async (caseId, documentId, documentType, selectedMsgs) => {
    try {
      const token = await AuthService.getCurrentToken();
      const payload = {
        caseId,
        documentId,
        documentType,
        messages: selectedMsgs.map((msg) => ({
          chatMessageId: msg.id || null,
          senderId: msg.senderId,
          senderName: msg.senderName || msg.title || '',
          receiverId: msg.receiverId,
          receiverName: msg.receiverName || '',
          messageType: msg.messageType ?? 0,
          text: msg.text || '',
          fileUrls: msg.fileUrls || msg.data?.uris || msg.data?.fileURLs || msg.data?.audioURLs || [],
          replyToChatMessageId: msg.replyToChatMessageId || msg.replyTo?.id || null,
          replyPreview: msg.replyPreview || msg.replyTo?.text || '',
          messageDate: msg.date ? new Date(msg.date).toISOString() : new Date().toISOString(),
        })),
      };

      const response = await ClarificationDocumentService.AttachClarificationMessages(payload, token);
      if (!response.ok) {
        throw new Error(await response.text());
      }

      const result = await response.json();
      toast.success(
        t('ClarificationMessagesAttached', { count: result?.attachedCount ?? selectedMsgs.length }) ||
        'Messages attached'
      );
    } catch (error) {
      console.error('Error attaching selected chat messages:', error);
      toast.error(error?.message || t('AttachClarificationMessagesFailed') || 'Failed to attach messages');
    }
  };

  const handleSearchDocumentSelect = async (row, sectionKey) => {
    const caseId = clarificationAttachContext?.caseId || targetUserIdRef.current;
    const documentType = sectionKey || row?.docType || row?.documentType;
    if (!caseId || !row?.id || !documentType) {
      toast.error(t('AttachClarificationMessagesFailed') || 'Failed to attach messages');
      return;
    }
    setDocPickerOpen(false);
    await attachMessagesToDocument(caseId, row.id, documentType, pendingAttachMessages);
    setPendingAttachMessages([]);
  };

  const handleAttachMessagesToItem = async (selectedMsgs) => {
    await openDocPicker(selectedMsgs);
  };


  const filteredForwardUsers = useMemo(() => {
    if (!forwardUserSearch.trim()) return forwardChatUsers;
    const query = forwardUserSearch.toLowerCase();
    return forwardChatUsers.filter(u =>
      u.userName?.toLowerCase().includes(query)
    );
  }, [forwardChatUsers, forwardUserSearch]);

  const buildWavBlob = (pcmChunks, sampleRate) => {
    let totalLength = 0;
    for (const chunk of pcmChunks) totalLength += chunk.length;

    const pcm = new Float32Array(totalLength);
    let off = 0;
    for (const chunk of pcmChunks) {
      pcm.set(chunk, off);
      off += chunk.length;
    }

    const buffer = new ArrayBuffer(44 + pcm.length * 2);
    const view = new DataView(buffer);
    const w = (o, s) => { for (let i = 0; i < s.length; i++) view.setUint8(o + i, s.charCodeAt(i)); };

    w(0, 'RIFF');
    view.setUint32(4, 36 + pcm.length * 2, true);
    w(8, 'WAVE');
    w(12, 'fmt ');
    view.setUint32(16, 16, true);
    view.setUint16(20, 1, true);
    view.setUint16(22, 1, true);
    view.setUint32(24, sampleRate, true);
    view.setUint32(28, sampleRate * 2, true);
    view.setUint16(32, 2, true);
    view.setUint16(34, 16, true);
    w(36, 'data');
    view.setUint32(40, pcm.length * 2, true);

    let o = 44;
    for (let i = 0; i < pcm.length; i++) {
      const s = Math.max(-1, Math.min(1, pcm[i]));
      view.setInt16(o, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
      o += 2;
    }
    return new Blob([buffer], { type: 'audio/wav' });
  };

  const handleRecordingStart = async () => {
    try {
      if (isRecording) {
        alert("Recording is already in progress.");
        return;
      }

      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        alert("Microphone access is not supported in your browser.");
        return;
      }

      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      micStreamRef.current = stream;

      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      const source = audioContext.createMediaStreamSource(stream);

      // AnalyserNode for real-time metering (waveform visualization)
      const analyser = audioContext.createAnalyser();
      analyser.fftSize = 256;
      source.connect(analyser);
      analyserRef.current = analyser;

      const dataArray = new Uint8Array(analyser.frequencyBinCount);
      meteringIntervalRef.current = setInterval(() => {
        analyser.getByteFrequencyData(dataArray);
        let sum = 0;
        for (let i = 0; i < dataArray.length; i++) sum += dataArray[i];
        const avg = sum / dataArray.length;
        meteringLevelRef.current = avg > 0 ? -55 + (avg / 255) * 55 : -160;
      }, 80);

      // ScriptProcessorNode captures raw PCM — produces WAV, same as mobile's AAC/MP4
      const processor = audioContext.createScriptProcessor(4096, 1, 1);
      pcmChunksRef.current = [];
      processor.onaudioprocess = (e) => {
        const input = e.inputBuffer.getChannelData(0);
        pcmChunksRef.current.push(new Float32Array(input));
      };
      source.connect(processor);
      processor.connect(audioContext.destination);

      audioContextRef.current = audioContext;

      if (chatService.current) {
        chatService.current.isRecording(targetUserIdRef.current, targetUserTypeRef.current, true);
      }
      setRecorder({ processor, source });
      setIsRecording(true);
    } catch (error) {
      console.error("Error starting recording:", error);
      alert("Failed to start recording.");
      setIsRecording(false);
    }
  };

  const stopRecordingCleanup = () => {
    if (meteringIntervalRef.current) {
      clearInterval(meteringIntervalRef.current);
      meteringIntervalRef.current = null;
    }
    meteringLevelRef.current = -160;
    analyserRef.current = null;

    if (recorder) {
      try { recorder.source?.disconnect(); } catch (e) {}
      try { recorder.processor?.disconnect(); } catch (e) {}
    }

    if (micStreamRef.current) {
      micStreamRef.current.getTracks().forEach(t => t.stop());
      micStreamRef.current = null;
    }

    const sampleRate = audioContextRef.current?.sampleRate;
    if (audioContextRef.current) {
      audioContextRef.current.close().catch(() => {});
      audioContextRef.current = null;
    }

    return sampleRate || 44100;
  };

  const handleRecordingStop = async () => {
    try {
      if (!isRecording) {
        alert("No recording is in progress.");
        return;
      }

      if (chatService.current) {
        chatService.current.isRecording(targetUserIdRef.current, targetUserTypeRef.current, false);
      }

      const sampleRate = stopRecordingCleanup();
      setIsRecording(false);
      setRecorder(null);

      const wavBlob = buildWavBlob(pcmChunksRef.current, sampleRate);
      pcmChunksRef.current = [];

      const audioUrl = URL.createObjectURL(wavBlob);
      const senderName = await AuthService.getCurrentUserTypeName();

      const newMessage = {
        id: uuid(),
        position: "right",
        type: "audio",
        text: "",
        date: moment().tz("Asia/Jerusalem").toDate(),
        dateString: formatMessageDate(moment().tz("Asia/Jerusalem").toDate()),
        title: senderName,
        senderId: userId,
        senderName,
        receiverId: targetUserId,
        receiverName: targetUserName,
        messageType: 3,
        fileUrls: [audioUrl],
        data: { audioURLs: [audioUrl] },
        sending: true,
      };

      setMessages((prevMessages) => [...prevMessages, newMessage]);

      try {
        const formData = new FormData();
        formData.append("SenderId", userId);
        formData.append("SenderName", senderName);
        formData.append("SenderType", userType);
        formData.append("ReceiverId", targetUserId);
        formData.append("ReceiverType", targetUserType);
        formData.append("MessageType", "3");
        formData.append("MessageContent", "");

        const file = new File([wavBlob], `audio-${Date.now()}.wav`, { type: 'audio/wav' });
        formData.append("Files", file);

        if (replyingMessageRef.current) {
          formData.append('ReplyToMessageId', replyingMessageRef.current.id);
        }

        const response = await ChatApiService.sendMessage(formData);

        setMessages((prev) =>
          updateMessageWithServerResponse(prev, newMessage.id, response?.data, replyingMessageRef.current)
        );
      } catch (error) {
        console.error("Error sending audio message:", error);
        setMessages((prevMessages) =>
          prevMessages.map((msg) =>
            msg.id === newMessage.id ? { ...msg, sending: "failed" } : msg
          )
        );
      }
    } catch (error) {
      console.error("Error stopping recording:", error);
      alert("Failed to stop recording.");
    }

    setReplyingMessage(null);
    replyingMessageRef.current = null;
  };

  const handleCancelRecording = () => {
    try {
      if (!isRecording) {
        alert("No recording is in progress.");
        return;
      }
      if (chatService.current) {
        chatService.current.isRecording(targetUserIdRef.current, targetUserTypeRef.current, false);
      }
      stopRecordingCleanup();
      pcmChunksRef.current = [];
      setIsRecording(false);
      setRecorder(null);
    } catch (error) {
      console.error("Error canceling recording:", error);
    }
  };


  /**
   * ------------------------------
   *       Draggable Modal
   * ------------------------------
   */
  if (!isOpen) {
    // Keep the component's hooks in place but don't render anything
    return createPortal(null, container);
  }





  // The actual UI of the chat (web-based)
  const modalContent = (
    <Draggable nodeRef={draggableNodeRef} handle=".handle" defaultPosition={{ x: 0, y: 0 }}>
      <div ref={draggableNodeRef} className={`chat-modal-container ${direction}`}>
        {/* HEADER */}
        <div className={`chat-modal-header handle`}>
          <div className="header-left-section">
            <span className="chat-app-title">{t('Chat')}</span>
          </div>
          <div className="header-right-section">
            <button className="close-btn" onClick={onClose}>
              <FiX size={18} />
            </button>
          </div>
        </div>

        {/* MAIN LAYOUT */}
        <div className="chat-page-layout">
          {/* LEFT SIDEBAR */}
          <div className="chat-page-sidebar">
            <div className="chat-page-sidebar-upper">

              <div className="sidebar-header">
                {(viewMode === 'users' && currentUserTypeRef.current?.toString() !== Constants.UserType.Client) && (
                  <FilterOptionMenu
                    optionGroups={optionGroups}
                    selectedOptions={selectedOptions}
                    setSelectedOptions={setSelectedOptions}
                    height='48px'
                  />
                )}

                <TextField
                  fullWidth
                  placeholder={t('searchClient')}
                  value={searchQuery}
                  onChange={handleSearchChange}
                  className="search-bar"
                  variant="standard"
                  InputProps={{
                    disableUnderline: true,
                    className: `custom-input-box-sizing-toggle ${direction === 'ltr' ? 'ltr-input' : 'rtl-input'}`,
                    sx: {
                      height: '48px',
                      padding: '0 10px',
                      borderRadius: '8px',
                      background: 'white',
                      border: '1px solid transparent',
                      '&:focus-within': {
                        border: '2px solid var(--Foundation-Blue-Normal, #304FFF)',
                      },
                    },
                    ...(direction === 'ltr'
                      ? {
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton edge="end" style={{ marginRight: '10px' }}>
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }
                      : {
                        startAdornment: (
                          <InputAdornment position="start">
                            <IconButton edge="start" style={{ marginLeft: '10px' }}>
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }),
                  }}
                  inputProps={{
                    style: {
                      textAlign: direction === 'ltr' ? 'left' : 'right',
                    },
                  }}
                />

              </div>
              {
                currentUserTypeRef.current?.toString() !== Constants.UserType.Client &&
                <div className={`sidebar-viewmode ${direction}`}>
                  <button
                    className={viewMode === 'users' ? 'active' : ''}
                    onClick={() => setViewMode('users')}
                  >
                    <FaUserFriends />
                    {t('Users')}
                  </button>
                  <button
                    className={viewMode === 'labels' ? 'active' : ''}
                    onClick={() => setViewMode('labels')}
                  >
                    <FaUsers />
                    {t('DistributionList')}
                  </button>
                </div>
              }

            </div>

            {viewMode === 'users' && (
              // <div className="chat-list-container">

              // </div>
              <ContactsList
                filteredAllowedUsers={filteredAllowedUsers}
                onUserSelect={onUserSelect}
                isLoading={false}
                t={t}
              />
            )}

            {viewMode === 'labels' && (
              <>

                <div className="create-label-modal-add-remove-container">
                  <div
                    className="create-label-modal-add-button"
                    onClick={handleOpenModal}
                  >
                    <AddCircleIcon className="create-label-modal-add-icon" />
                  </div>
                </div>
                <LabelsList
                  labels={filteredLabels} // Array of label objects
                  onLabelSelect={onLabelSelect} // Function to handle label selection
                  onLabelDelete={handleDelete} // Function to handle label deletion
                  translate={t} // Translation function
                  isLoading={loading} // Boolean for loading state
                />
              </>

            )}
          </div>

          {/* MAIN CHAT AREA */}

          <div className="chat-page-main">
            {isSearchMode ? (
              <>
                <ChatHeader
                  selectedUser={selectedUser}
                  isTyping={isTyping}
                  isTargetRecording={isTargetRecording}
                  isOnline={isOnline}
                  deselectUser={deselectUser}
                  handleSearchSubmit={handleSearchSubmit}
                  onCancelSearch={onCancelSearch}
                  isSearchMode={isSearchMode}
                  setIsSearchMode={setIsSearchMode}
                  searchChatQuery={searchChatQuery}
                  setSearchChatQuery={setSearchChatQuery}
                  getAllForReceiver={getAllForReceiver}
                  setGetAllForReceiver={changeForReceiver}
                  userType={currentUserTypeRef.current}
                />

                <div className="search-results">
                  {searchResults.length > 0 ? (
                    searchResults.map((item) => (
                      <SearchItem
                        key={item.messageId}
                        item={item}
                        currentUserId={currentUserIdRef.current}
                        targetName={targetUserNameRef.current}
                        onSelect={handleSelectSearchResult}
                      />
                    ))

                  ) : (
                    <p className="no-results">{t('NoResultForYourSearch')}</p>
                  )}

                </div>

              </>

            ) : selectedUser ? (
              <>
                <ChatHeader
                  selectedUser={selectedUser}
                  isTyping={isTyping}
                  isTargetRecording={isTargetRecording}
                  isOnline={isOnline}
                  deselectUser={deselectUser}
                  handleSearchSubmit={handleSearchSubmit}
                  onCancelSearch={onCancelSearch}
                  isSearchMode={isSearchMode}
                  setIsSearchMode={setIsSearchMode}
                  searchChatQuery={searchChatQuery}
                  setSearchChatQuery={setSearchChatQuery}
                  getAllForReceiver={getAllForReceiver}
                  setGetAllForReceiver={changeForReceiver}
                  userType={currentUserTypeRef.current}
                />

                <div className="chat-page-messages">
                  <ChatMessagesList
                    messages={messages}
                    containerHeight={650}
                    onClickImage={handleImageClick}
                    onScroll={handleScroll}
                    lowestPageLoaded={lowestPageLoaded}
                    highestPageLoaded={highestPageLoaded}
                    getAllForReceiver={getAllForReceiver}
                    refreshMessages={reloadMessages}
                    onReplyToMessage={handleReplyToMessage}
                    onScrollToIndex={scrollToIndexRef}
                    scrollContainerRef={scrollContainerRef}
                    onRepliedMessageClick={handleRepliedMessageClick}
                    onForwardMessages={handleForwardMessages}
                    onAttachMessages={
                      [Constants.UserType.Accountant, Constants.UserType.SubAccountant].includes(currentUserTypeRef.current?.toString())
                      && targetUserTypeRef.current?.toString() === Constants.UserType.Client
                        ? handleAttachMessagesToItem
                        : null
                    }
                    attachActionLabel={t('AttachConversation')}
                  />
                </div>


                <ChatInputBar
                  handleSendMessage={handleSendMessage}
                  handleAttachFiles={(files) => handleAttachFiles(files)}
                  handleRecordingStart={handleRecordingStart}
                  handleRecordingStop={handleRecordingStop}
                  handleCancelRecording={handleCancelRecording}
                  setIsRecording={setIsRecording}
                  isRecording={isRecording}
                  isTyping={isTyping}
                  isTargetRecording={isTargetRecording}
                  chatService={chatService.current}
                  targetUserId={targetUserId}
                  targetUserType={targetUserType}
                  replyingMessage={replyingMessage}
                  clearReply={() => {
                    setReplyingMessage(null);
                    replyingMessageRef.current = null;
                  }}
                  meteringLevelRef={meteringLevelRef}
                />
              </>

            ) :
              (
                <div className="xtram-chat-title">
                  Xtram {t('Chat')}
                </div>
              )}
          </div>


          {loading && (
            <div className="loader-container2">
              <PuffLoader
                size={100}        // Larger size for better visibility
                loading={loading}
              />
            </div>
          )}

        </div>
        <CustomDeleteConfirmationModal
          isVisible={isModalVisible}
          onClose={handleCloseDelete}
          onDelete={onLabelDelete}
          confirmMessage={t('confirmDeleteMessage')}
          titleMessage={t('confirmDeleteTitle')}
        />
        <CreateLabelModal
          visible={showCreateLabelModal}
          onClose={() => setShowCreateLabelModal(false)}
          onLabelCreated={onLabelCreated}
          setLoading={setLoading}
          loading={loading}
        />

        {/* Forward to Chat - User Picker Dialog */}
        <Dialog
          open={showForwardPicker}
          onClose={() => {
            setShowForwardPicker(false);
            setForwardUserSearch('');
            setMessagesToForward([]);
          }}
          maxWidth="sm"
          fullWidth
          PaperProps={{
            sx: { borderRadius: '16px', maxHeight: '70vh' }
          }}
        >
          <DialogTitle sx={{ textAlign: 'center', fontWeight: 600 }}>
            {t('SelectChatUser')}
          </DialogTitle>
          <DialogContent>
            <TextField
              fullWidth
              size="small"
              placeholder={t('SearchUsers')}
              value={forwardUserSearch}
              onChange={(e) => setForwardUserSearch(e.target.value)}
              sx={{ mb: 2 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            {loadingForwardUsers ? (
              <div style={{ display: 'flex', justifyContent: 'center', padding: 20 }}>
                <CircularProgress />
              </div>
            ) : filteredForwardUsers.length === 0 ? (
              <Typography sx={{ textAlign: 'center', color: '#999', py: 3 }}>
                {t('NoUsersFound')}
              </Typography>
            ) : (
              <List sx={{ maxHeight: 400, overflow: 'auto' }}>
                {filteredForwardUsers.map((user) => (
                  <ListItem key={user.userId} disablePadding>
                    <ListItemButton onClick={() => handleForwardToUser(user)}>
                      <ListItemAvatar>
                        <Avatar sx={{ bgcolor: '#304FFF' }}>
                          {user.userName?.charAt(0)?.toUpperCase() || '?'}
                        </Avatar>
                      </ListItemAvatar>
                      <MuiListItemText primary={user.userName} />
                      <SendIcon sx={{ color: '#304FFF', fontSize: 20 }} />
                    </ListItemButton>
                  </ListItem>
                ))}
              </List>
            )}
          </DialogContent>
        </Dialog>

        {docPickerOpen && searchToken && searchAccountantId && (
          <TransactionSearchResultModal
            open={docPickerOpen}
            onClose={() => {
              setDocPickerOpen(false);
              setPendingAttachMessages([]);
            }}
            caseId={clarificationAttachContext?.caseId || targetUserId}
            accountantId={searchAccountantId}
            token={searchToken}
            client={hamburgerClient?.caseId === (clarificationAttachContext?.caseId || targetUserId)
              ? hamburgerClient
              : { caseId: clarificationAttachContext?.caseId || targetUserId }}
            user={hamburgerUser || { accountantId: searchAccountantId }}
            accountsData={accountCardOptions}
            sortCodes={sortCodeIdOptions}
            onSelectDocument={handleSearchDocumentSelect}
            dialogZIndex={2000}
          />
        )}
      </div>
    </Draggable >
  );

  // Render the chat portal
  return createPortal(modalContent, container);
}
